/* Diwali footer firecrackers (Diwali 2026). Loaded (defer) only by snippets/mes-diwali-fireworks.liquid,
   which renders only while the campaign is Diwali 2026 and never on the cart page.
   Port of the design's fstart / fdraw: one fountain at centre + seven rockets bursting in gold,
   orange, red and indigo, ~5 s, then the canvas clears. Starts at 45% in view, replays on every
   fresh entry (after leaving view entirely), pauses off-screen, never runs under reduced motion. */
(function () {
  'use strict';
  if (window.__mesDiwaliFw) return;
  window.__mesDiwaliFw = true;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var C = ['#E8A317', '#F26A21', '#D8283F', '#B8862F', '#FFC83D', '#3B2A8A'];
  var R = Math.random;
  function pk(a) { return a[Math.floor(R() * a.length)]; }

  function init(cv) {
    var ctx = cv.getContext && cv.getContext('2d');
    if (!ctx) return;
    var X = null, raf = 0, inView = false, armed = true, pausedAt = 0;

    function start() {
      X = { t0: performance.now(), p: [], r: [], q: [[0.3, 0.12], [1, 0.88], [1.8, 0.3], [2.6, 0.7], [3.4, 0.5], [4.2, 0.2], [4.6, 0.82]] };
      loop();
    }
    function loop() { if (!raf) raf = requestAnimationFrame(step); }
    function stop(clear) {
      if (raf) cancelAnimationFrame(raf); raf = 0;
      if (clear) { X = null; ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, cv.width, cv.height); }
    }
    function step(now) {
      raf = 0;
      if (!X || !inView || !cv.isConnected) return;
      raf = requestAnimationFrame(step);
      draw(now);
    }
    function draw(now) {
      var Wd = cv.clientWidth || 1264, Hd = cv.clientHeight || 340, dpr = Math.min(2, window.devicePixelRatio || 1);
      if (cv.width !== Math.round(Wd * dpr) || cv.height !== Math.round(Hd * dpr)) { cv.width = Math.round(Wd * dpr); cv.height = Math.round(Hd * dpr); }
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0); ctx.clearRect(0, 0, Wd, Hd); ctx.globalCompositeOperation = 'source-over';
      var t = (now - X.t0) / 1000, k = Math.min(2, (now - (X.l || now - 16)) / 16.7); X.l = now;
      if (t < 5.6) {
        var g = ctx.createRadialGradient(Wd / 2, Hd, 0, Wd / 2, Hd, 120);
        g.addColorStop(0, 'rgba(255,170,70,.25)'); g.addColorStop(1, 'rgba(255,170,70,0)');
        ctx.fillStyle = g; ctx.fillRect(Wd / 2 - 120, Hd - 120, 240, 120);
        for (var i = 0; i < 5; i++) {
          var a = -Math.PI / 2 + (R() - 0.5) * 0.55, s = 6 + R() * 5;
          X.p.push({ x: Wd / 2, y: Hd, vx: Math.cos(a) * s, vy: Math.sin(a) * s, l: 1, d: 0.014 + R() * 0.01, c: pk(C.slice(0, 4)), s: 1.6, g: 0.2, k: 1 });
        }
      }
      while (X.q.length && t >= X.q[0][0]) {
        var q = X.q.shift();
        X.r.push({ x: Wd * q[1], y: Hd, vx: (R() - 0.5) * 0.6, vy: -(9.5 + R() * 2), ty: 50 + R() * 110, c: pk(C) });
      }
      X.r = X.r.filter(function (r) {
        r.x += r.vx * k; r.y += r.vy * k; r.vy *= 0.992;
        X.p.push({ x: r.x, y: r.y, vx: (R() - 0.5) * 0.6, vy: R() * 0.6, l: 0.6, d: 0.05, c: '#F2A93B', s: 1.2, g: 0.04, k: 1 });
        ctx.globalAlpha = 1; ctx.fillStyle = '#B4560C'; ctx.beginPath(); ctx.arc(r.x, r.y, 2.2, 0, 6.3); ctx.fill();
        if (r.y <= r.ty) {
          var n = 72, c1 = r.c, c2 = pk(C);
          for (var j = 0; j < n; j++) {
            var an = 6.283 * j / n + R() * 0.1, sp = (j % 2 ? 3.4 : 2.1) * (0.8 + R() * 0.4);
            X.p.push({ x: r.x, y: r.y, vx: Math.cos(an) * sp, vy: Math.sin(an) * sp, l: 1, d: 0.011 + R() * 0.006, c: j % 2 ? c1 : c2, s: 1.8, g: 0.045, k: 0.985 });
          }
          return false;
        }
        return true;
      });
      X.p = X.p.filter(function (p) {
        p.vx *= p.k; p.vy = p.vy * p.k + p.g * k; p.x += p.vx * k; p.y += p.vy * k; p.l -= p.d * k;
        if (p.l <= 0 || p.y > Hd + 10) return false;
        ctx.globalAlpha = Math.min(1, p.l); ctx.fillStyle = p.c; ctx.beginPath(); ctx.arc(p.x, p.y, p.s * 0.8, 0, 6.3); ctx.fill();
        if (p.k !== 1 && p.l > 0.5) { ctx.globalAlpha = Math.min(1, p.l) * 0.5; ctx.fillStyle = '#FFF6D8'; ctx.beginPath(); ctx.arc(p.x, p.y, p.s * 0.35, 0, 6.3); ctx.fill(); }
        return true;
      });
      ctx.globalAlpha = 1;
      if (t > 7 && !X.p.length && !X.r.length) stop(true);
    }

    var io = new IntersectionObserver(function (es) {
      var e = es[es.length - 1];
      if (!e.isIntersecting) {
        // Fully out: pause what is running and arm a replay for the next entry.
        if (inView) { inView = false; if (raf) { cancelAnimationFrame(raf); raf = 0; } pausedAt = performance.now(); }
        armed = true;
        return;
      }
      if (e.intersectionRatio >= 0.45 && armed) { armed = false; inView = true; start(); return; }
      if (!inView) {
        inView = true;
        if (X) { var gap = performance.now() - pausedAt; X.t0 += gap; X.l = 0; loop(); }
      }
    }, { threshold: [0, 0.45] });
    io.observe(cv);
  }

  function boot() { document.querySelectorAll('[data-mdw-fireworks]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
